import i18next, { InitOptions } from "i18next";
import nl from "./nl";
import { initReactI18next } from "react-i18next";
import de from "./de";
import en from "./en";

export const resources: InitOptions["resources"] = {
  nl: {
    translation: nl,
  },
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

i18next.use(initReactI18next).init({
  interpolation: {
    escapeValue: false,
  },
  fallbackLng: "nl",
  lng: sessionStorage.getItem("language") ?? "nl",
  resources,
});

export type Translation = typeof nl;
export default i18next;
